import { SlideData } from './types';

// NOTE: In a real deployment, replace these URLs with the local file paths provided by the user.
// e.g., '/assets/robot_brown.png', etc.
// I am using high-quality 3D robot/tech placeholders to simulate the look.

export const HERO_SLIDES: SlideData[] = [
  {
    id: 1,
    image: '/images/pro-1.jpg', 
    title: "嗨，我叫歪觅",
    subtitle: "AI双轮足陪伴机器人",
    theme: 'light'
  },
  {
    id: 2,
    image: '/images/pro-2.jpg', 
    title: "我能陪你聊天",
    subtitle: "丝滑的语音交互系统",
    theme: 'light'
  },
  // {
  //   id: 3,
  //   image: '/images/3.png', 
  //   title: "我能认出家人",
  //   subtitle: "先进的声源方位识别以及声纹识别",
  //   theme: 'light'
  // },
  // {
  //   id: 4,
  //   image: '/images/4.png',
  //   title: "我懂你的情绪",
  //   subtitle: "情绪识别系统定期推送心情日记",
  //   theme: 'light'
  // },
  // {
  //   id: 5,
  //   image: '/images/4.png',
  //   title: "我记得你说过的话",
  //   subtitle: "长记忆存储",
  //   theme: 'light'
  // }
];

export const COMPANY_NAME_EN = "WYNDME";
export const COMPANY_NAME_CN = "奎牛智能科技（广州）有限公司";
export const CONTACT_EMAIL = "wyndme@qq.com";
